var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSnowflake(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 356 408.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #344c60;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 15px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 177.74,
    y1: 7.5,
    x2: 177.74,
    y2: 401.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.5,
    y1: 105.79,
    x2: 348.5,
    y2: 302.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.5,
    y1: 302.36,
    x2: 348.5,
    y2: 105.49
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "226.41 39.58 177.74 88.25 129.07 39.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "59.36 79.83 77.17 146.31 10.69 164.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "10.69 244.62 77.17 262.44 59.36 328.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "129.07 369.17 177.74 320.5 226.41 369.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "296.12 328.92 278.3 262.44 344.79 244.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "344.79 164.13 278.3 146.31 296.12 79.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "208.16 118.94 177.74 149.35 147.32 118.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "120.48 136.83 131.61 178.39 90.06 189.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "90.06 219.23 131.61 230.36 120.48 271.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "147.32 289.81 177.74 259.4 208.16 289.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "235 271.92 223.87 230.36 265.42 219.23"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "265.42 189.52 223.87 178.39 235 136.83"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowflake);
export default __webpack_public_path__ + "static/media/snowflake.3f3935aab3be342ebb175495bc2a12fc.svg";
export { ForwardRef as ReactComponent };